/**
 * now-on.js - fills the offer price into "Now on at Glowming" cards
 * (sections/now-on.liquid).
 *
 * A card with data-now-offer="<key>" is rendered HIDDEN and carries the token
 * [price] in its title/text. This file reads the Business App's offers endpoint
 * through window.GlowmingOffers (assets/journey-offers.js: same fetch, same
 * 60-second session cache), finds the RUNNING offer with that key, writes its
 * VAT-inclusive rand amount over [price], and only then shows the card.
 *
 * No answer, a failed answer, or an offer that is not running: the card stays
 * hidden. The theme never shows a price it made up or one that has expired.
 */
(function () {
  'use strict';

  if (typeof window !== 'undefined' && window.GlowmingNowOn) return;

  var TOKEN = '[price]';

  /**
   * Format a whole-rand amount the way the site writes prices: "R999", "R1,157".
   * Anything that is not a finite, non-negative number gives null.
   *
   * @param {unknown} amount
   * @returns {string|null}
   */
  function formatRand(amount) {
    if (typeof amount !== 'number' || !isFinite(amount) || amount < 0) return null;
    var whole = Math.round(amount * 100) % 100 === 0;
    var fixed = whole ? String(Math.round(amount)) : amount.toFixed(2);
    var parts = fixed.split('.');
    parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, ',');
    return 'R' + parts.join('.');
  }

  /**
   * The price text for one offer key, or null when the offer is not running.
   *
   * @param {object|null} payload - the endpoint's "ok" answer
   * @param {string} key
   * @returns {string|null}
   */
  function priceFor(payload, key) {
    if (!payload || !key || !Array.isArray(payload.offers)) return null;
    var offer = payload.offers.filter(function (o) { return o && o.key === key; })[0];
    if (!offer || offer.currency !== 'ZAR') return null;
    return formatRand(offer.amount);
  }

  /** Replace the token in every text node under an element (no HTML is parsed). */
  function fillToken(element, price) {
    var walker = element.ownerDocument.createTreeWalker(element, 4 /* NodeFilter.SHOW_TEXT */);
    var node = walker.nextNode();
    while (node) {
      if (node.nodeValue.indexOf(TOKEN) !== -1) node.nodeValue = node.nodeValue.split(TOKEN).join(price);
      node = walker.nextNode();
    }
  }

  /** Show every offer card whose offer is running, filled with its price. */
  function apply(root, payload) {
    var cards = Array.prototype.slice.call(root.querySelectorAll('[data-now-offer]'));
    cards.forEach(function (card) {
      var price = priceFor(payload, card.getAttribute('data-now-offer'));
      if (!price) return;
      card.querySelectorAll('[data-now-price-text]').forEach(function (el) { fillToken(el, price); });
      card.hidden = false;
    });
  }

  function start() {
    var O = window.GlowmingOffers;
    if (!O) return;
    Array.prototype.slice.call(document.querySelectorAll('[data-now-on]')).forEach(function (root) {
      var endpoint = root.getAttribute('data-offers-endpoint');
      if (!endpoint) return;
      var cached = O.readCache(window.sessionStorage, Date.now());
      if (cached) { apply(root, cached); return; }
      O.fetchOffers(endpoint).then(function (payload) {
        if (!payload) return;
        O.writeCache(window.sessionStorage, Date.now(), payload);
        apply(root, payload);
      });
    });
  }

  window.GlowmingNowOn = { TOKEN: TOKEN, formatRand: formatRand, priceFor: priceFor, apply: apply };

  if (typeof document !== 'undefined' && document.querySelectorAll) {
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start);
    else start();
  }
})();
